/**
 * @generated SignedSource<<722ca4ae1e27996c83a42e042e3c199a>>
 * @relayHash c8cf0add8d2dcc6a27da80f124652cae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bbfd7fcdb1c0633ad6d955f535af5811fa647ba90b403676076ee37a3f4cde26

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CapacityWorkViewContentQuery } from './CapacityWorkViewContentQuery.graphql';

import isAiImportEnabled_provider from '../../../../../../../platform/packages/capacity-planning/capacity-planning-core/src/ui/capacity-planning-core/table/common/cell/contribution-cell/../../../../../../is-ai-import-enabled.relayprovider';

const node: PreloadableConcreteRequest<CapacityWorkViewContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "bbfd7fcdb1c0633ad6d955f535af5811fa647ba90b403676076ee37a3f4cde26",
    "metadata": {},
    "name": "CapacityWorkViewContentQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__isaiimportenabledrelayprovidertsx": isAiImportEnabled_provider
    }
  }
};

export default node;
